export default __webpack_public_path__ + "static/media/nz.29afa191.svg";